<div class="container-fluid Container-First">
  <app-header *ngIf="router.url!='/login' "></app-header>

  <div class="Main-fluid">
    <!-- <div class="Sidebar">
      <app-sidebar *ngIf="showSidebar()"></app-sidebar>
    </div> -->
    

    <div class="main-container" >
      <router-outlet></router-outlet> 
    </div>
  </div>

  <app-footer *ngIf="router.url!='/login'"></app-footer>
  <!-- <p-toast></p-toast> -->
</div>
